import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface TyuExperienceConfig {
  show_tyu_experience: boolean;
  is_lesson_in_tyu_experiment: boolean;
}

const tyuExperienceConfig: Module<TyuExperienceConfig, RootState> = {
  namespaced: true,
  state: {
    show_tyu_experience: false,
    is_lesson_in_tyu_experiment: false,
  },
  getters: {
    showTYUExperience: (state: TyuExperienceConfig): boolean => state.show_tyu_experience,
    isLessonInTyuExperiment: (state: TyuExperienceConfig): boolean =>
      state.is_lesson_in_tyu_experiment,
  },
  mutations: {
    setValue(state: TyuExperienceConfig, value: TyuExperienceConfig): void {
      Object.assign(state, value);
    },
  },
};

export default tyuExperienceConfig;
